@if (items && items.length) {
  <div>
    <div class="form-group">
      <div class="search-holder">
        <cpq-input [label]="{key: '', placeholder: 'Search'}" #searchItems="ngModel" [name]="'searchItems'"
        [(ngModel)]='searchQuery' (ngModelChange)="search()" (focusout)="hasSearchResults=true"></cpq-input>
        <span [ngClass]="{'sap-icon': true, 'search-icon': !searchQuery, 'close-icon': searchQuery}"
        (click)="clearCategorySearchInput()"></span>
      </div>
      @if (displayNoResultsSearchMessage) {
        <ul class="no-results">
          <li>
            {{'Admin.Msg.NoResultsSearch' | translate}}
          </li>
        </ul>
      }
    </div>
    @if (!items) {
      <mat-spinner></mat-spinner>
    }
    <div class="items-holder">
      @if (data.isMultiSelect) {
        <div class="flex-center-between">
          <span class='show-only-selected'>
            <mat-checkbox [(ngModel)]="showOnlySelectedItems" (change)="setShowOnlySelectedState($event.checked)" [disabled]='!this.selectedItems || !this.selectedItems.length'>{{'Msg.ShowOnlySelected' | translate}}</mat-checkbox>
          </span>
          <div class="select-all-label">
            <a (click)="selectAll()">{{'xsltSelectAll' | translate}}</a>
            <span> | </span>
            <a (click)="deselectAll()">{{'Admin.SetupSpa.DeselectAll' | translate}}</a>
          </div>
        </div>
      }
      <ul class="main-list cpq-scroll">
        @if (data.isMultiSelect) {
          <li>
            @if (data.multiSelectTitle) {
              <h4 class="padding-top-20">{{data.multiSelectTitle | translate}}</h4>
            }
          </li>
        }
        <ng-container *ngTemplateOutlet="recursiveList; context:{ items: items }"></ng-container>
      </ul>
    </div>
    @if (data.showApplyPermissionsToggle) {
      <div class="permissions-toggle">
        <cpq-toggle #applyPermissionsToggle="ngModel" [(ngModel)]="applyPermissions" (ngModelChange)='applyPermissionsChanged.emit($event)'
          [name]="'applyPermissionsToggle'"
        [label]="{key: 'CategoryModifications.ApplyPermissionsFromParentCategory'}"></cpq-toggle>
      </div>
    }
  </div>
}

<ng-template class="holder" #recursiveList let-items="items">
  @for (item of items; track item) {
    <li>
      @if (item.isVisible) {
        <div class="text-container"
          [ngClass]="{'selected': item.isSelected, 'has-subcategory':item.children && item.children.length}"
          >
          <span *any="item.children" class="expand-container" [ngClass]="{'rotate': !item.isCollapsed}"
            (click)="expandCollapse(item)">
            <span class="sap-icon chevron-down">&#xe1e2;</span>
          </span>
          <span [class.disabled]="item.isDisabled" class="itemname" (click)="select(item)" [title]="item.name">{{item.name}}</span>
          <span class="arrow-container"
            [ngClass]="{'selected': item.isSelected, 'disabled': item.isDisabled}"
            (click)="select(item)">
            @if (item.hasSelectedChildren) {
              <span class="sap-icon"
              [title]="hasSelectedChildrenTooltipText">&#xe224;</span>
            }
            @if (item.isSelected) {
              <span class="sap-icon">&#xe05b;</span>
            }
          </span>
        </div>
      }
      <ul *any="item.children" class="subcategory">
        <ng-container *ngTemplateOutlet="recursiveList; context:{ items: item.children }"></ng-container>
      </ul>
    </li>
  }
</ng-template>